module.exports = __webpack_public_path__ + "img/chapter__3_image_1.36805fde.png";